__turbopack_context__.v({
  "image": "NudgeCard-module__bbdZaa__image",
  "root": "NudgeCard-module__bbdZaa__root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
  "text": "NudgeCard-module__bbdZaa__text",
});
